import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class StatesStatusWiseResponseModel extends GlobalResponseObject {
    active?: number;
    inActive?: number;
    total?: number;
}

